import React, { useState, useEffect, useRef } from 'react';
import { Button, Spin } from 'antd';
import Logo from '../../components/Logo/Logo';
import OtpInput from 'react-otp-input';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import userStore from '../../zustand/store/userStore';
import { resendOtpAPI } from '../../zustand/API';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OtpScreen = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const email = location.state?.email;
	const { authToken, userOtpVerify, user, data, loading } = userStore();

	const [otp, setOtp] = useState('');
	const [timer, setTimer] = useState(120); 
	const [isResendEnabled, setIsResendEnabled] = useState(false);

	const timerRef = useRef(null);

	useEffect(() => {
		if (authToken) {
			if (user?.role === 'student') navigate('/student-dashboard');
			else if (user?.role === 'teacher') navigate('/teacher-dashboard');
			else if (user?.role === 'admin') navigate('/admin-dashboard');
			else if (user?.role === 'parent') navigate('/parent-dashboard');
		}
		if (data?.otpSend) {
			navigate('/otp-verify');
		}
	}, [authToken, data, navigate, user]);

	useEffect(() => {
		if (timer > 0) {
			setIsResendEnabled(false);
			timerRef.current = setInterval(() => {
				setTimer((prev) => prev - 1);
			}, 1000);
		} else {
			setIsResendEnabled(true);
		}

		return () => clearInterval(timerRef.current);
	}, [timer]);

	const handleResend = async () => {
		if (!isResendEnabled) return;

		clearInterval(timerRef.current);
		setTimer(120);
		setIsResendEnabled(false);

		const targetEmail = data?.email || data?.otpSend?.email || email;
		const result = await resendOtpAPI(targetEmail);
		console.log('result :', result)
		if (result?.status === 200) {
			toast.success('OTP resent successfully');
		} else {
			toast.error(result?.message || 'Failed to resend OTP');
		}
	};

	const handleVerify = async () => {
		const params = {
			email: data?.email || data?.otpSend?.email || email,
			otp,
		};
		await userOtpVerify(params);
	}

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		return `${minutes}:${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds}`;
	};

	return (
		<div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
			<div className="bg-white p-6 rounded-2xl shadow-lg w-96 text-center">
				<div className="mb-4">
					<div className="w-12 h-12 mx-auto mb-2">
						<Logo />
					</div>
					<h2 className="text-xl font-semibold">Sign in to your account</h2>
				</div>
				<p className="text-gray-600 mb-4">Sent OTP on Your Email</p>
				<div className="flex justify-center gap-2 mb-4">
					<OtpInput
						value={otp}
						onChange={setOtp}
						numInputs={4}
						renderSeparator={<span className="mx-1">-</span>}
						renderInput={(props) => (
							<input
								{...props}
								className="h-10 text-center text-xl border-2 border-gray-300 rounded-md focus:outline-none focus:border-green-500 mx-1"
								type="number"
								inputMode="numeric"
								maxLength={1}
							/>
						)}
						inputStyle={{ width: '32px' }}
					/>
				</div>
				<Button
					type="primary"
					className="w-full h-10 bg-green-500 border-none rounded-lg"
					onClick={handleVerify}
				>
					{loading ? <Spin /> : 'Verify Account'}
				</Button>
				<p className="mt-4 text-gray-600">
					Resend:
					<a
						className={`text-green-500 pl-3 ${isResendEnabled ? 'cursor-pointer' : 'cursor-not-allowed'}`}
						onClick={handleResend}
					>
						{isResendEnabled ? 'OTP Again' : formatTime(timer)}
					</a>
				</p>
			</div>
		</div>
	);
};

export default OtpScreen;